<!--
  WhereaboutsInfo.vue
    メンバ行動予定情報 Component
-->

<!-- -------------------------------------------------------------------------------- -->
<template>
  <div @click="selectWhereaboutsInfo(pWhereaboutsInfo)">

    <div v-if="(pViewMode === 'grid') && (pWhereaboutsInfo.user_id === '')"></div>
    <div v-else>

    <v-divider />
    <v-card flat class="hm-wai-place-card">

      <!-- Mobile Layout -->
      <div :class="{'hm-hide': (pViewMode !== 'mobile')}">
        <v-layout wrap align-center>
          <v-flex xs2 text-xs-center>
            <div :class="{'hm-hide': (pWhereaboutsInfo.telework_flg === 0)}" class="hm-wai-teleworking-icon">
              <span class="pa-1"><v-icon small dark>home_work</v-icon></span>
            </div>
            <div :class="{'hm-hide': !isAvatarAvailable}">
              <v-avatar>
                <img :src="this.imgSrc">
              </v-avatar>
            </div>
            <div :class="{'hm-hide': isAvatarAvailable}">
              <v-avatar color="grey lighten-1">
                <v-icon color="grey lighten-4">person</v-icon>
              </v-avatar>
            </div>
          </v-flex>
          <v-flex xs10>
            <div>
              <v-layout wrap align-center>
                <v-flex xs5>
                  <div class="hm-wai-card-name-xs hm-ellipsis">{{ pWhereaboutsInfo.name }}</div>
                  <div class="hm-wai-card-distname hm-ellipsis">{{ pWhereaboutsInfo.dist_name }}</div>
                </v-flex>
                <v-flex xs1>
                  <div class="hm-wai-card-icon">
                    <place-icon :pStatusId="pWhereaboutsInfo.state" :pViewMode="'mobile'" />
                  </div>
                </v-flex>
                <!--
                <v-flex xs4 text-xs-center class="hm-wai-card-place-xs hm-ellipsis">{{ pWhereaboutsInfo.dist_name }}</v-flex>
                -->
                <v-flex xs2>
                  <!-- colorを動的に変更できるtext componentがないのでbuttonをflatで使う -->
                  <v-btn flat icon small :color="currentPresence.icon_color" class="hm-wai-stname-outer">
                    <div class="hm-wai-stname hm-ellipsis">{{ currentPresence.st_name }}</div>
                  </v-btn>
                </v-flex>
                <v-flex xs1><div :class="{'hm-hidden': !goDirect}" class="hm-wai-direct-mobile-go">行</div></v-flex>
                <v-flex xs1><div :class="{'hm-hidden': !comeDirect}" class="hm-wai-direct-mobile-bk">帰</div></v-flex>
                <v-flex xs2 class="hm-wai-card-return">{{ pWhereaboutsInfo.v_ret_date }}<br />{{ pWhereaboutsInfo.v_ret_time }}</v-flex>
              </v-layout>
            </div>
            <div class="hm-wai-card-comment hm-ellipsis">
              {{ filteredComment }}
            </div>
          </v-flex>
        </v-layout>
      </div>

      <!-- Monitor Layout (Screen mode OFF) -->
      <!-- @Todo できればpViewModeにmenulistは使いたくない -->
      <div :class="{'hm-hide': (pViewMode !== 'column')}">
        <v-layout wrap align-center v-resize="onResize">

          <v-flex xs1 text-xs-center>
            <div :class="{'hm-hide': (pWhereaboutsInfo.telework_flg === 0)}" class="hm-wai-teleworking-icon">
              <span class="pa-1"><v-icon small dark>home_work</v-icon></span>
            </div>
            <div :class="{'hm-hide': !isAvatarAvailable}">
              <v-avatar :size="this.mAvatarSizeClm">
                <img :src="this.imgSrc">
              </v-avatar>
            </div>
            <div :class="{'hm-hide': isAvatarAvailable}">
              <v-avatar :size="this.mAvatarSizeClm" color="grey lighten-1">
                <v-icon :size="this.mAvatarIconSizeClm" color="grey lighten-4">person</v-icon>
              </v-avatar>
            </div>
          </v-flex>

          <v-flex xs11>
            <div>
              <v-layout wrap align-center>
                <v-flex xs3 class="hm-wai-card-name-clm hm-ellipsis">{{ pWhereaboutsInfo.name }}</v-flex>
                <v-flex xs1>
                  <!--
                  <div v-if="updateDateDisp" class="hm-wai-card-icon">
                    <v-tooltip bottom>
                      <place-icon slot="activator" :pStatusId="pWhereaboutsInfo.state" :pViewMode="'menulist'" />
                      <span>最終更新  {{ pWhereaboutsInfo.update_date | formatUpdateDate }}</span>
                    </v-tooltip>
                  </div>
                  -->
                  <div class="hm-wai-card-icon">
                    <place-icon :pStatusId="pWhereaboutsInfo.state" :pViewMode="'menulist'" />
                  </div>
                </v-flex>
                <v-flex xs1>
                  <!-- colorを動的に変更できるtext componentがないのでbuttonをflatで使う -->
                  <v-btn flat icon small :color="currentPresence.icon_color" class="hm-wai-stname-outer">
                    <div class="hm-wai-stname hm-ellipsis">{{ currentPresence.st_name }}</div>
                  </v-btn>
                </v-flex>
                <v-flex xs4 class="hm-wai-card-place-clm hm-ellipsis">{{ pWhereaboutsInfo.dist_name }}</v-flex>
                <v-flex xs1>
                  <div :class="{'hm-hidden': !goDirect}" class="hm-wai-direct-go">直行</div>
                  <div :class="{'hm-hidden': !comeDirect}" class="hm-wai-direct-bk">直帰</div>
                </v-flex>
                <v-flex xs2 class="hm-wai-card-return">{{ filteredRetDate }}<br />{{ filteredRetTime }}</v-flex>
              </v-layout>
            </div>
            <div class="hm-wai-card-comment hm-ellipsis">
              {{ filteredComment }}
            </div>
          </v-flex>
        </v-layout>
      </div>

      <!-- Monitor Layout (Screen mode ON / 1 column) -->
      <div :class="{'hm-hide': (pViewMode !== 'wide1col')}">
        <v-layout wrap align-center v-resize="onResize">

          <v-flex xs1 text-xs-center class="hm-wai-avatar">
            <div :class="{'hm-hide': (pWhereaboutsInfo.telework_flg === 0)}" class="hm-wai-teleworking-icon-wide">
              <span class="pa-1"><v-icon dark>home_work</v-icon></span>
            </div>
            <div :class="{'hm-hide': !isAvatarAvailable}">
              <v-avatar :size="this.mAvatarSizeScreen">
                <img :src="this.imgSrc">
              </v-avatar>
            </div>
            <div :class="{'hm-hide': isAvatarAvailable}">
              <v-avatar :size="this.mAvatarSizeScreen" color="grey lighten-1">
                <v-icon :size="this.mAvatarIconSize" color="grey lighten-4">person</v-icon>
              </v-avatar>
            </div>
          </v-flex>

          <v-flex xs11>
            <div>
              <v-layout wrap align-center>
                <v-flex xs3 class="hm-wai-card-name-wide hm-ellipsis">{{ pWhereaboutsInfo.name }}</v-flex>
                <v-flex xs1>
                  <!--
                  <div v-if="updateDateDisp" class="hm-wai-card-icon">
                    <v-tooltip bottom>
                      <place-icon slot="activator" :pStatusId="pWhereaboutsInfo.state" :pViewMode="'monitor'" />
                      <span>最終更新 [ {{ pWhereaboutsInfo.update_date | formatUpdateDate }} ]</span>
                    </v-tooltip>
                  </div>
                  -->
                  <div class="hm-wai-card-icon">
                    <place-icon :pStatusId="pWhereaboutsInfo.state" :pViewMode="'monitor'" />
                  </div>
                </v-flex>
                <v-flex xs2>
                  <!-- colorを動的に変更できるtext componentがないのでbuttonをflatで使う -->
                  <v-btn flat icon small :color="currentPresence.icon_color" class="hm-wai-stname-outer">
                    <div class="hm-wai-stname-wide hm-ellipsis">{{ currentPresence.st_name }}</div>
                  </v-btn>
                </v-flex>
                <v-flex xs3 class="hm-wai-card-place-wide hm-ellipsis">{{ pWhereaboutsInfo.dist_name }}</v-flex>
                <v-flex xs1>
                  <div :class="{'hm-hidden': !goDirect}" class="hm-wai-direct-wide-go">直行</div>
                  <div :class="{'hm-hidden': !comeDirect}" class="hm-wai-direct-wide-bk">直帰</div>
                </v-flex>
                <v-flex xs1 class="hm-wai-card-return-wide">{{ filteredRetDate }}</v-flex>
                <v-flex xs1 class="hm-wai-card-return-wide">{{ filteredRetTime }}</v-flex>
              </v-layout>
            </div>
            <div class="hm-wai-card-comment hm-wai-card-comment-scroll1col hm-ellipsis">
              {{ filteredComment }}
            </div>
          </v-flex>
        </v-layout>
      </div>

      <!-- Monitor Layout (Screen mode ON / 2 column) -->
      <div :class="{'hm-hide': (pViewMode !== 'wide2col')}">
        <v-layout wrap align-center v-resize="onResize">

          <v-flex xs2 text-xs-center class="hm-wai-avatar">
            <div :class="{'hm-hide': (pWhereaboutsInfo.telework_flg === 0)}" class="hm-wai-teleworking-icon-wide">
              <span class="pa-1"><v-icon dark>home_work</v-icon></span>
            </div>
            <div :class="{'hm-hide': !isAvatarAvailable}">
              <v-avatar :size="this.mAvatarSizeScreen">
                <img :src="this.imgSrc">
              </v-avatar>
            </div>
            <div :class="{'hm-hide': isAvatarAvailable}">
              <v-avatar :size="this.mAvatarSizeScreen" color="grey lighten-1">
                <v-icon :size="this.mAvatarIconSize" color="grey lighten-4">person</v-icon>
              </v-avatar>
            </div>
          </v-flex>

          <v-flex xs10>
            <div>
              <v-layout wrap align-center>
                <v-flex xs5 class="hm-wai-card-name-wide hm-ellipsis">{{ pWhereaboutsInfo.name }}</v-flex>
                <v-flex xs2>
                  <!--
                  <div v-if="updateDateDisp" class="hm-wai-card-icon">
                    <v-tooltip bottom>
                      <place-icon slot="activator" :pStatusId="pWhereaboutsInfo.state" :pViewMode="'monitor'" />
                      <span>最終更新 [ {{ pWhereaboutsInfo.update_date | formatUpdateDate }} ]</span>
                    </v-tooltip>
                  </div>
                  -->
                  <div class="hm-wai-card-icon">
                    <place-icon :pStatusId="pWhereaboutsInfo.state" :pViewMode="'monitor'" />
                  </div>
                </v-flex>
                <v-flex xs2>
                  <!-- colorを動的に変更できるtext componentがないのでbuttonをflatで使う -->
                  <v-btn flat icon small :color="currentPresence.icon_color" class="hm-wai-stname-outer">
                    <div class="hm-wai-stname-wide hm-ellipsis">{{ currentPresence.st_name }}</div>
                  </v-btn>
                </v-flex>
                <v-flex xs1>
                  <div :class="{'hm-hidden': !goDirect}" class="hm-wai-direct-wide-go hm-wai-direct-wide-2col">直行</div>
                  <div :class="{'hm-hidden': !comeDirect}" class="hm-wai-direct-wide-bk hm-wai-direct-wide-2col">直帰</div>
                </v-flex>
                <v-flex xs2 class="hm-wai-card-return-wide hm-wai-card-return-wide-2col">
                  {{ filteredRetDate }}<br />
                  {{ filteredRetTime }}
                </v-flex>
              </v-layout>
            </div>
            <div class="hm-wai-card-comment hm-wai-card-comment-scroll2col hm-ellipsis">
              {{ filteredComment }}
            </div>
          </v-flex>
        </v-layout>
      </div>

      <!-- Monitor Layout (Screen mode ON / Grid) -->
      <div
        :class="{'hm-hide': (pViewMode !== 'grid')}"
        :style="{'height': pGridHeight, 'border': borderStyleStr}"
        style="border-radius: 7px;"
      >
        <v-layout
          wrap
          align-center
          v-resize="onResize"
        >
          <!-- プロフィール画像 -->
          <v-flex xs4 text-xs-center class="hm-wai-avatar-grid">
            <div :class="{'hm-hide': (pWhereaboutsInfo.telework_flg === 0)}" class="hm-wai-teleworking-icon-wide">
              <v-icon small dark class="pa-1">home_work</v-icon>
            </div>
            <div :class="{'hm-hide': !isAvatarAvailable}">
              <v-avatar :size="this.mAvatarSizeGrid">
                <img :src="this.imgSrc">
              </v-avatar>
            </div>
            <div :class="{'hm-hide': isAvatarAvailable}">
              <v-avatar :size="this.mAvatarSizeGrid" color="grey lighten-1">
                <v-icon :size="this.mAvatarIconSizeGrid" color="grey lighten-4">person</v-icon>
              </v-avatar>
            </div>
          </v-flex>

          <v-flex xs8>
            <!-- 在席アイコン -->
            <div :style="{'background': stIconColor}" class="hm-wai-stname-outer-grid hm-ellipsis">
              <v-icon color="white" small>{{ currentPresence.icon_name }}</v-icon>
              <span>{{ currentPresence.st_name }}</span>
            </div>

            <!-- 名前 -->
            <div class="hm-wai-card-name-grid hm-ellipsis">
              {{ pWhereaboutsInfo.name }}
            </div>

            <!-- コメント、帰社日時(帰社日時が未選択の場合は非表示) -->
            <v-layout v-if="pWhereaboutsInfo.v_ret_date !== '' || pWhereaboutsInfo.v_ret_time !== ''">
              <v-flex xs9>
                <div class="hm-wai-card-comment-grid hm-ellipsis">
                  {{ filteredComment }}
                </div>
              </v-flex>
              <v-flex xs3 class="hm-wai-card-return-wide-grid">
                <span v-if="pWhereaboutsInfo.v_ret_date !== ''">
                  <span v-if="pWhereaboutsInfo.v_ret_time === ''"><br /></span>
                  {{ pWhereaboutsInfo.v_ret_date }}
                </span><br />
                <span v-if="pWhereaboutsInfo.v_ret_date === '' || pWhereaboutsInfo.v_ret_time !== ''">
                  {{ pWhereaboutsInfo.v_ret_time }}
                </span>
              </v-flex>
            </v-layout>
            <v-layout v-else>
              <div class="hm-wai-card-comment-grid hm-ellipsis">
                {{ filteredComment }}
              </div>
            </v-layout>
          </v-flex>
        </v-layout>
      </div>

    </v-card>
    <v-divider />

    </div>
  </div>
</template>

<!-- -------------------------------------------------------------------------------- -->
<script>
//import moment from 'moment'
import { ROUTE_PATH } from '@/router/routes'
import { mapState } from 'vuex'
import PlaceIcon from '@/components/parts/PlaceIcon'
import colors from 'vuetify/lib/util/colors'
import { TIME_DIFERENCE, isNullorUndefined, formatDateMoment, calcHour } from '@/common'

export default {
  name: 'WhereaboutsInfo',
  props: [ 'pWhereaboutsInfo', 'pViewMode', 'pLastStaffId', 'pGridHeight' ],
  data: () => ({
    mStrDate: '',  // 表示用日付
    mStrTime: '',  // 表示用時刻
    mAvatarSizeScreen: window.innerWidth * 0.06,  // Avatar Size
    mAvatarSizeClm: window.innerWidth * 0.04,  // Avatar Size
    mAvatarSizeGrid: parseInt(this.pGridHeight) * 0.80,  // Avatar Size
    mAvatarIconSize: window.innerWidth * 0.04,
    mAvatarIconSizeClm: window.innerWidth * 0.03,
    mAvatarIconSizeGrid: parseInt(this.pGridHeight) * 0.75,
    mStNameStyle: {
      color: 'red',
    },
    mPresenceDefault: {
      state_id: 0,
      st_name: '-',
      icon_name: 'error',
      icon_color: 'grey lighten-2',
    }
  }),
  components: {
    'place-icon': PlaceIcon,
  },
  filters: {
    formatUpdateDate: function (time) {
      if (isNullorUndefined(time) || time === '') {
        return ''
      }
      return formatDateMoment(calcHour(time, TIME_DIFERENCE), 'YYYY-MM-DD HH:mm')
    },
  },
  mounted: function () {
    //this.$log.debug('# WhereaboutsInfo mode(' + this.pViewMode + ') id(' + this.pWhereaboutsInfo.staff_id + ') (' + moment().format('YYYY-MM-DD HH:mm:ss:SSS')  + ')')
    //this.$log.debug(this.pWhereaboutsInfo)
    this.$log.debug('# WhereaboutsInfo')
  },
  destroyed: function () {
    this.$log.debug('# WhereaboutsInfo')
  },
  computed: {
    ...mapState({
      mPresenceStatusList: state => state.sPresenceStatusList,
      mDispItem: state => state.systemSettings.sDispItem,
    }),
    // -------------------------------------------------------------------------
    imgSrc: function () {
      const userlist = this.$store.getters.userList
      const userinfo = userlist.find((userinfo) => {
        return (userinfo.user_id.toString() === this.pWhereaboutsInfo.user_id.toString())
      })
      if (isNullorUndefined(userinfo)) {
        this.$log.error('userinfo is null or undefined.')
        return ''
      }

      // キャッシュを使わず画像を更新したいため ? + Date をつける
      return (isNullorUndefined(userinfo.avatar) || userinfo.avatar === '')
        ? userinfo.avatar : userinfo.avatar + '?' + Date.now()
    },
    // -------------------------------------------------------------------------
    isAvatarAvailable: function () {
      const userList = this.$store.getters.userList
      const userinfo = userList.find((userinfo) => {
        return (userinfo.user_id.toString() === this.pWhereaboutsInfo.user_id.toString())
      })
      if (isNullorUndefined(userinfo)) {
        return false
      }
      else {
        if (isNullorUndefined(userinfo.avatar) || (userinfo.avatar === '')) {
          return false
        }
        else {
          return true
        }
      }
    },
    // -------------------------------------------------------------------------
    /*isTeleworking: function () {
      let result = false
      if (this.pWhereaboutsInfo.telework_flg !== 1) {
        // テレワークユーザでは無い場合
        return false
      }

      // 表示対象のstaff_idが、テレワーク勤務中ユーザリストに存在するか検索
      const twUserist = this.$store.getters.teleworkingUserList
      if (isNullorUndefined(twUserist)) {
        return false
      }
      if (twUserist.indexOf(this.pWhereaboutsInfo.staff_id) >= 0) {
        result = true
      }
      return result
    },*/
    // -------------------------------------------------------------------------
    goDirect: function () {
      return (this.pWhereaboutsInfo.move_direct === 1) || (this.pWhereaboutsInfo.move_direct === 3)
    },
    // -------------------------------------------------------------------------
    comeDirect: function () {
      return (this.pWhereaboutsInfo.move_direct === 2) || (this.pWhereaboutsInfo.move_direct === 3)
    },
    // -------------------------------------------------------------------------
    filteredRetDate: function () {
      if (this.pWhereaboutsInfo.v_ret_date === '') {
        // 帰社日が未入力の場合は全角スペース(表示エリア確保のため)
        return '　'
      }
      return this.pWhereaboutsInfo.v_ret_date
    },
    // -------------------------------------------------------------------------
    filteredRetTime: function () {
      if (this.pWhereaboutsInfo.v_ret_time === '') {
        // 帰社時間が未入力の場合は全角スペース(表示エリア確保のため)
        return '　'
      }
      return this.pWhereaboutsInfo.v_ret_time
    },
    // -------------------------------------------------------------------------
    filteredComment: function () {
      // 最後の社員IDの場合は、Loading表示をOFF
      // (一番最後に呼び出されるcomputedであるため、ここでOFFにする)
      if (this.pWhereaboutsInfo.staff_id === this.pLastStaffId) {
        this.$emit('lastStaffMounted')
      }

      let comment = ''
      if ((this.pViewMode === 'wide2col' || this.pViewMode === 'grid') && this.mDispItem === '0') {
        // スクリーン表示ONの２列表示またはグリッド表示、
        // かつ、ログインユーザが表示項目「行先リスト」を選択している場合
        if (this.pWhereaboutsInfo.dist !== '0') {
          comment = this.pWhereaboutsInfo.dist_name
        }
      }
      else {
        comment = this.pWhereaboutsInfo.comment
      }

      // eslint-disable-next-line
      let tmpComment = (!!(comment)) ? comment : ''
      if (tmpComment.trim().length === 0) {
        tmpComment = '　'   // メモ欄未入力の場合、表示エリアが非表示にならないように全角スペースに置き換え
      }
      return tmpComment
    },
    currentPresence: function () {
      return this._findPresenceStatus(this.pWhereaboutsInfo.state)
    },
    updateDateDisp: function () {
      return !(isNullorUndefined(this.pWhereaboutsInfo.update_date) || this.pWhereaboutsInfo.update_date === '')
    },
    borderStyleStr: function () {
      //return ('solid 3px var(--v-' + this.currentPresence.icon_color + ')')
      return ('solid 3px ' + this._getColorCodeFromMaterialColor(this.currentPresence.icon_color))
    },
    stIconColor: function () {
      return this._getColorCodeFromMaterialColor(this.currentPresence.icon_color)
    }
  },
  methods: {
    // -------------------------------------------------------------------------
    onResize: function () {
      this.mAvatarSizeScreen = window.innerWidth * 0.06
      this.mAvatarSizeClm = window.innerWidth * 0.04
      this.mAvatarSizeGrid = parseInt(this.pGridHeight) * 0.80
      this.mAvatarIconSize = window.innerWidth * 0.04
      this.mAvatarIconSizeClm = window.innerWidth * 0.03
      this.mAvatarIconSizeGrid = parseInt(this.pGridHeight) * 0.75
    },
    // -------------------------------------------------------------------------
    // Member選択時の処理
    selectWhereaboutsInfo: function (whereabouts) {
      if (this.$store.getters.isMobile) {
        this._selectWhereaboutsInfoMobile(whereabouts)
      }
      else {
        this._selectWhereaboutsInfoMonitor(whereabouts)
      }
    },
    // -------------------------------------------------------------------------
    // Member選択時の処理(Monitor)
    _selectWhereaboutsInfoMonitor: function (whereabouts) {
      this.$emit('whereaboutsInfoSelected', whereabouts.user_id)
    },
    // -------------------------------------------------------------------------
    // Member選択時の処理(Mobile)
    _selectWhereaboutsInfoMobile: function (whereabouts) {
      this.$router.push(ROUTE_PATH.ROUTE_WHEREABOUTS_INFO + '/' + whereabouts.user_id)
    },
    // -------------------------------------------------------------------------
    _findPresenceStatus: function (statusId) {
      let presenceStatus = this.mPresenceStatusList.find((elm) => {
        return (elm.state_id.toString() === statusId.toString())
      })

      if (isNullorUndefined(presenceStatus)) {
        this.$log.error('current presence status is null.')
        // 見つからない場合はdefault値を返す
        return this.mPresenceDefault
      }
      return presenceStatus
    },
    // -------------------------------------------------------------------------
    // マテリアルカラーの名称をカラーコードに変換
    _getColorCodeFromMaterialColor: function (colorName) {
      let colorArray = colorName.split(' ')
      let category = colorArray[0]
      let colorNameArray = category.split('-')
      if (colorNameArray.length >= 2) {
        category = colorNameArray[0] + colorNameArray[1].slice(0, 1).toUpperCase() + colorNameArray[1].slice(1)
      }
      let sub = 'base'
      if (colorArray.length >= 2) {
        sub = colorName.split(' ')[1].replace('-', '')
      }
      let code = colors[category][sub]
      return code
    },
  }
}
</script>

<!-- -------------------------------------------------------------------------------- -->
<style scoped>
/* カード内設定 */
.hm-wai-place-card:hover {
  background-color: #eeeeee;
}
.hm-wai-avatar,
.hm-wai-avatar-grid {
  padding: 5px 0;
}
.hm-wai-card-icon {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.hm-wai-card-name-xs {
  padding: 5px;
  font-weight: bold;
}
.hm-wai-card-name-clm {
  padding: 5px;
  font-weight: bold;
  font-size: 1.5vw;
}
.hm-wai-card-name-sm,
.hm-wai-card-name-wide {
  padding: 5px;
  font-weight: bold;
  font-size: 2.3vw;
}
.hm-wai-card-name-grid {
  margin-top: 15px;
  padding-left: 2px;
  font-weight: bold;
  font-size: 1.4vw;
}
.hm-wai-card-place-xs {
  padding: 5px;
}
.hm-wai-card-place-clm {
  padding-left: 10px;
  font-size: 1.25vw;
}
.hm-wai-card-place-sm,
.hm-wai-card-place-wide {
  font-size: 2vw;
}
.hm-wai-card-distname {
  font-size: 3vw;
  padding-bottom: 1px;
}
.hm-wai-card-comment {
  background-color: #f5f5f5;
}
@media screen and (min-width: 601px) and (max-width: 960px) {
.hm-wai-card-comment {
  font-size: 2vw;
}
}
@media screen and (min-width: 961px) {
.hm-wai-card-comment {
  font-size: 1.25vw;
}
.hm-wai-card-comment-scroll1col,
.hm-wai-card-comment-scroll2col {
  font-size: 1.75vw;
}
}
.hm-wai-card-comment-scroll1col {
  max-width: 92vw;
}
.hm-wai-card-comment-scroll2col {
  max-width: 45vw;
}
.hm-wai-card-comment-grid {
  width: 100%;
  max-width: 18vw;
  bottom: 0;
  right: 0;
  margin: 0;
  padding: 1px 1px 1px 5px;
  font-size: 1.1vw
}

.hm-wai-card-return {
  text-align: center;
  font-size: 0.9em;
}
.hm-wai-stname-outer {
  width: 100% !important;
  margin: 3px;
}
.hm-wai-stname-outer-grid {
  position: absolute;
  width: 35%;
  min-width: 80px;
  margin: 0;
  top: 0;
  right: 0;
  font-size: 0.85vw;
  color: white;
  padding: 3px 1px 1px 5px;
  border-bottom-left-radius: 2px;
  border-top-right-radius: 7px;
}
.hm-wai-stname {
  width: 100%;
  text-align: left;
  font-size: 0.85em;
}
.hm-wai-stname-clm {
  width: 100%;
  text-align: left;
  font-size: 1.25vw;
}
.hm-wai-stname-wide {
  width: 100%;
  text-align: left;
  font-size: 1.4vw;
  font-weight: bold;
}
@media screen and (min-width: 601px) {
.hm-wai-card-return {
  padding: 0px;
  font-size: 1.25vw;
  font-weight: bold;
}
}
.hm-wai-card-return-wide {
  padding: 0px;
  font-size: 2.25vw;
  font-weight: bold;
}
.hm-wai-card-return-wide-2col {
  font-size: 1.7vw;
}
.hm-wai-card-return-wide-grid {
  font-size: 0.9vw;
  padding-left: 5px;
  margin-top: -10px;
}
.hm-wai-direct-go {
  margin: 1px 2px;
  text-align: center;
  color: #8b0000;
  background-color: white;
  border: solid 1px #8b0000;
  border-radius: 3px;          /* css3 draft */
  -webkit-border-radius: 3px;  /* Safari, Chrome */
  -moz-border-radius: 3px;     /* Firefox */
  font-size: 0.8em;
}
.hm-wai-direct-bk {
  margin: 1px 2px;
  text-align: center;
  color: white;
  background-color: #8b0000;
  border: solid 1px #8b0000;
  border-radius: 3px;          /* css3 draft */
  -webkit-border-radius: 3px;  /* Safari, Chrome */
  -moz-border-radius: 3px;     /* Firefox */
  font-size: 0.8em;
}
.hm-wai-direct-wide-go {
  margin: 1px 15px;
  text-align: center;
  color: #8b0000;
  background-color: white;
  border: solid 1px #8b0000;
  border-radius: 3px;          /* css3 draft */
  -webkit-border-radius: 3px;  /* Safari, Chrome */
  -moz-border-radius: 3px;     /* Firefox */
  font-size: 1.1vw;
}
.hm-wai-direct-wide-bk {
  margin: 1px 15px;
  text-align: center;
  color: white;
  background-color: #8b0000;
  border: solid 1px #8b0000;
  border-radius: 3px;          /* css3 draft */
  -webkit-border-radius: 3px;  /* Safari, Chrome */
  -moz-border-radius: 3px;     /* Firefox */
  font-size: 1.1vw;
}
.hm-wai-direct-wide-2col {
  margin: 1px 3px;
}
.hm-wai-direct-mobile-go {
  margin: 1px 2px;
  text-align: center;
  font-size: 0.9em;
  color: #8b0000;
  background-color: white;
  border: solid 1px #8b0000;
  border-radius: 3px;          /* css3 draft */
  -webkit-border-radius: 3px;  /* Safari, Chrome */
  -moz-border-radius: 3px;     /* Firefox */
}
.hm-wai-direct-mobile-bk {
  margin: 1px 2px;
  text-align: center;
  font-size: 0.9em;
  color: white;
  background-color: #8b0000;
  border: solid 1px #8b0000;
  border-radius: 3px;          /* css3 draft */
  -webkit-border-radius: 3px;  /* Safari, Chrome */
  -moz-border-radius: 3px;     /* Firefox */
}
.hm-wai-teleworking-icon,
.hm-wai-teleworking-icon-wide {
  position: absolute;
  top: 5px;
  z-index: 1;
  border-radius: 50%;
  background-color: #8b0000;
}
</style>



// WEBPACK FOOTER //
// src/components/WhereaboutsInfo.vue